import { postNewsletter } from 'services/apis/submit-newsletter';
import { SUBMIT_ACCOUNT_TO_NEWSLETTER } from 'constants/newsletter';

export const postNewsletterAction = (data) => ({
  type: SUBMIT_ACCOUNT_TO_NEWSLETTER,
  payload: postNewsletter(data),
});
